module.exports = __webpack_public_path__ + "img/login-bg-hand.82a9c946.png";